import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import navIcon1 from '../assets/img/ig.png';
import navIcon2 from '../assets/img/logowp.png';

import logoPinta from '../assets/img/PINTA MKT NEGATIVO.png';
import { HashLink } from 'react-router-hash-link';
import {
  BrowserRouter as Router
} from "react-router-dom";


export const NavBar = ({ onShowPortfolio }) => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

  return (
    <Router>
      <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand href="/">
            {/* Logo de tu marca */}
            <img style={{
              width: "200px",
              height: "auto",
              borderRadius: "10px",
            }} src={logoPinta} alt="LinkedIn" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link 
                href="#home" 
                className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} 
                onClick={() => onUpdateActiveLink('home')}
              >
                Inicio
              </Nav.Link>
            
              <Nav.Link 
                href="#projects" 
                className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} 
                onClick={() => onUpdateActiveLink('projects')}
              >
                Servicios
              </Nav.Link>

              <Nav.Link 
                href="#" 
                className={activeLink === '#' ? 'active navbar-link' : 'navbar-link'} 
                onClick={onShowPortfolio}
              >
                Proyectos
              </Nav.Link>

              <Nav.Link 
                href="#skills" 
                className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} 
                onClick={() => onUpdateActiveLink('skills')}
              >
                Clientes
              </Nav.Link>
            </Nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a 
                  href="https://www.instagram.com/pintamkt/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <img src={navIcon1} alt="Instagram" />
                </a>
              </div>

              <div className="social-icon">
                <a 
                  href="https://api.whatsapp.com/send?phone=5492612061502" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <img src={navIcon2} alt="WhatsApp" style={{ width: "26px", height: "26px" }} />
                </a>
              </div>

              <HashLink to="#connect">
                <button className="vvd">
                  <span>Hablemos</span>
                </button>
              </HashLink>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  );  
}
